import { Car, TriangleAlert, Truck, Wrench } from "lucide-react";
import { services } from "./config";
import { EditableText } from "./TextEditor";

export const HeroSection = ({ imageSlots, fallbackHeroImage = "" }) => {
  return (
    <section id="top" data-testid="hero-section" className="hero-section" style={{ "--hero-image": imageSlots.hero ? `url(${imageSlots.hero})` : fallbackHeroImage ? `url(${fallbackHeroImage})` : "none" }}>
      <div data-testid="hero-overlay" className="hero-overlay" />
      <div data-testid="hero-grid" className="hero-grid" />
      <div className="container hero-content">
        <div data-testid="hero-copy" className="hero-copy animate-rise">
          <EditableText textId="hero.eyebrow" defaultText="Centrale operativa Viscar" as="span" testId="hero-eyebrow" className="section-eyebrow hero-eyebrow" />
          <EditableText textId="hero.headline" defaultText="SOCCORSO STRADALE H24" as="h1" testId="hero-headline" />
          <EditableText textId="hero.subtitle.operational" defaultText="Messina • Tremestieri • A18 • A20" as="p" testId="hero-subtitle" className="hero-subtitle" />
          <EditableText
            textId="hero.description"
            defaultText="Centrale operativa per soccorso leggero e pesante, recovery, recuperi complessi e officina mobile con partenza rapida da Messina verso città, svincolo di Tremestieri, A18 e A20."
            as="p"
            testId="hero-description"
            className="hero-description"
            multiline
          />
        </div>
      </div>
    </section>
  );
};

export const ServicesSection = () => (
  <section id="servizi" data-testid="services-section" className="section services-section">
    <div className="container">
      <div data-testid="services-grid" className="service-grid">
        {services.map((service, index) => {
          const icons = [Car, Truck, Wrench, TriangleAlert];
          const ServiceIcon = icons[index];
          return (
          <article data-testid={`service-card-${index}`} key={service.title} className="tech-card service-card animate-rise" style={{ animationDelay: `${index * 90}ms` }}>
            <ServiceIcon data-testid={`service-card-${index}-icon`} className="service-icon" size={30} />
            <EditableText textId={`services.card.${index}.title`} defaultText={service.title} as="h3" testId={`service-card-${index}-title`} />
            <EditableText textId={`services.card.${index}.description`} defaultText={service.description} as="p" testId={`service-card-${index}-description`} multiline />
          </article>
        );})}
      </div>
    </div>
  </section>
);